import PropTypes from 'prop-types';
import { useState } from 'react';
import { ArrowLink, Modal } from '@bwoty-web/ui-kit';

import FlightDetails from '../shared/flightDetails/FlightDetails';

import './mobileHeader.scss';

const MobileHeader = ({ transport, getFlightTime, labels }) => {
  const { homeBoundFlights, outBoundFlights, flightTimeInformation } =
    transport;
  const [isFlightInformationOpen, setIsFlightInformationOpen] = useState(false);

  const {
    departureDateDay,
    departureDateDayName,
    departureDateMonthName,
    departureTime,
  } = outBoundFlights[0];

  const showFlightInformationPopup = () => {
    if (!flightTimeInformation) {
      getFlightTime();
    }

    setIsFlightInformationOpen(true);
  };

  return (
    <div className="mobile-header">
      <div className="departure-date-time">
        <div className="departure-date-time__left-container">
          <div className="departure-date-time__day">{departureDateDay}</div>
          <div className="departure-date-time__weekday-month">
            <div className="departure-date-time__month">
              {departureDateMonthName.toUpperCase()}
            </div>
            <div className="departure-date-time__weekday">
              {departureDateDayName.toUpperCase()}
            </div>
          </div>
        </div>
        <div className="departure-date-time__right-container">
          <div className="departure-date-time__time-flight-link">
            <div className="departure-date-time__departure-time">
              <div className="departure-date-time__departure-label">
                {labels.outbound}
              </div>
              <div className="departure-date-time__time">{departureTime}</div>
            </div>
            <ArrowLink
              className="departure-date-time__flight-details-link"
              data-gtm-tag="Flight Info"
              onClick={showFlightInformationPopup}
            >
              <span>{labels.FlightDetailsLink}</span>
            </ArrowLink>
          </div>
        </div>
      </div>
      <Modal
        heading={labels.flightInformationLabel}
        isOpen={isFlightInformationOpen}
        onClose={() => setIsFlightInformationOpen(false)}
        size="l"
      >
        <FlightDetails
          flights={[outBoundFlights[0], homeBoundFlights[0]]}
          flightTimeInformation={flightTimeInformation}
          labels={labels}
        />
      </Modal>
      <div className="mobile-header__title">{labels.ChooseRoomType}</div>
    </div>
  );
};

MobileHeader.propTypes = {
  transport: PropTypes.shape({
    homeBoundFlights: PropTypes.arrayOf(
      PropTypes.shape({
        bookingEngineKey: PropTypes.string,
      }),
    ).isRequired,
    outBoundFlights: PropTypes.arrayOf(
      PropTypes.shape({
        bookingEngineKey: PropTypes.string,
        departureDateDay: PropTypes.string,
        departureDateDayName: PropTypes.string,
        departureDateMonthName: PropTypes.string,
        departureTime: PropTypes.string,
      }).isRequired,
    ),
    departureInformation: PropTypes.shape({
      day: PropTypes.string,
      dayName: PropTypes.string,
      departureTime: PropTypes.string,
      month: PropTypes.string,
    }),
    flightTimeInformation: PropTypes.shape({}),
  }),
  labels: PropTypes.shape({
    ChooseRoomType: PropTypes.string,
    FlightDetailsLink: PropTypes.string,
    flightInformationLabel: PropTypes.string,
    outbound: PropTypes.string,
  }).isRequired,
  getFlightTime: PropTypes.func.isRequired,
};

MobileHeader.defaultProps = {
  transport: {},
};

export default MobileHeader;
